import { i18n } from '@b2ag/locale'

import { type AppBrand } from '@b2ag/app-brands'
import { defaultBrandLang } from '@b2ag/app-brands/src/country-lang'
import { loadMessages } from '../../messages'

export const loadLocaleFor = async (brand: AppBrand, customLang?: string) => {
  let lang = customLang || defaultBrandLang()

  const locale = lang + '_' + brand.replace('-', '_')

  const customLocale = typeof window !== 'undefined' ? window.localStorage.getItem('customLocale') : undefined

  if (customLocale) lang = customLocale.split('_')[0]

  const messages = (await loadMessages(customLocale || locale)) || {}

  i18n.load(lang, messages)
  i18n.activate(lang)
}
